import styled, { css } from "styled-components";
import NumericTextField from "ui/common/components/input/NumericTextField/NumericTextField";

export const PointsBalanceFieldRoot = styled(NumericTextField)(
    () => css`
        .FormControlHint:not(.FormControlError) {
            text-align: start;
        }
    `,
);
